export default {
  regions: [
    {
      id: 188,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Republic of Karakalpakstan',
        ru: 'Республика Каракалпакстан',
        uz: 'Qoraqalpog`iston Respublikasi',
      },
      region_code: 1735,
    },
    {
      id: 177,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Khorezm region',
        ru: 'Хорезмская',
        uz: 'Xorazm viloyati',
      },
      region_code: 1733,
    },
    {
      id: 160,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Tashkent region',
        ru: 'Ташкентская',
        uz: 'Toshkent tumani',
      },
      region_code: 1727,
    },
    {
      id: 151,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Syrdarya region',
        ru: 'Сырдарьинская',
        uz: 'Sirdaryo viloyati',
      },
      region_code: 1724,
    },
    {
      id: 136,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Surkhandarya region',
        ru: 'Сурхандарьинская',
        uz: 'Surxandaryo viloyati',
      },
      region_code: 1722,
    },
    {
      id: 121,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Samarkand region',
        ru: 'Самаркандская',
        uz: 'Samarqand viloyati',
      },
      region_code: 1718,
    },
    {
      id: 112,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Navaiy',
        ru: 'Навоийская',
        uz: 'Navoiy viloyati',
      },
      region_code: 1712,
    },
    {
      id: 98,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Kashkadarya region',
        ru: 'Кашкадарьинская',
        uz: 'Qashqadaryo viloyati',
      },
      region_code: 1710,
    },
    {
      id: 76,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Jizzakh region',
        ru: 'Джизакская',
        uz: 'Jizzax viloyati',
      },
      region_code: 1708,
    },
    {
      id: 57,
      parent: null,
      created_date: '2021-06-02T05:00:00',
      modified_date: '2021-10-25T16:29:12.736000',
      name: {
        en: 'Fergana region',
        ru: 'Ферганская',
        uz: "Farg'ona viloyati",
      },
      region_code: 1730,
    },
  ],
  districts: [],
  stage_types: {
    results: [
      { uz: 'Yer usti', ru: 'Наземный' },
    ],
  },
  currencies: {
    results: [
      { title: { ru: 'Сум', uz: 'So\'m' }, id: 1 },
    ],
  },
  apartment_materials: {
    results: [],
  },
  premises_decorations: {
    results: [],
  },
  construction_stages: [],
  planning_types: [],
  output_windows: [],
  quarters: {
    results: [
      {
        id: 1,
        title: {
          uz: 'I kvartal',
          ru: 'I квартал',
        },
      },
      {
        id: 2,
        title: {
          uz: 'II kvartal',
          ru: 'II квартал',
        },
      },
      {
        id: 3,
        title: {
          uz: 'III kvartal',
          ru: 'III квартал',
        },
      },
      {
        id: 4,
        title: {
          uz: 'IV kvartal',
          ru: 'IV квартал',
        },
      },
    ],
  },
  months: [
    {
      id: 1,
      title: {
        uz: 'Yanvar',
        ru: 'Январь',
      },
    },
    {
      id: 2,
      title: {
        uz: 'Fevral',
        ru: 'Февраль',
      },
    },
    {
      id: 3,
      title: {
        uz: 'Mart',
        ru: 'Март',
      },
    },
    {
      id: 4,
      title: {
        uz: 'Aprel',
        ru: 'Апрель',
      },
    },
    {
      id: 5,
      title: {
        uz: 'May',
        ru: 'Май',
      },
    },
    {
      id: 6,
      title: {
        uz: 'Iyun',
        ru: 'Июнь',
      },
    },
    {
      id: 7,
      title: {
        uz: 'Iyul',
        ru: 'Июль',
      },
    },
    {
      id: 8,
      title: {
        uz: 'Avgust',
        ru: 'Август',
      },
    },
    {
      id: 9,
      title: {
        uz: 'Sentabr',
        ru: 'Сентябрь',
      },
    },
    {
      id: 10,
      title: {
        uz: 'Oktabr',
        ru: 'Октябрь',
      },
    },
    {
      id: 11,
      title: {
        uz: 'Noyabr',
        ru: 'Ноябрь',
      },
    },
    {
      id: 12,
      title: {
        uz: 'Dekabr',
        ru: 'Декабрь',
      },
    },
  ],
  apartment_types: {
    results: [
    ],
  },
  contruction_types: {
    results: [],
  },
  flat_statuses: {
    results: [
      {
        id: 1,
        title: {
          uz: '',
          ru: 'Свободно',
          en: 'available',
        },
        color: 'success',
      },
      {
        id: 2,
        title: {
          uz: '',
          ru: 'Забронировано',
          en: 'booked',
        },
        color: 'warning',
      },
      {
        id: 3,
        title: {
          uz: 'Sotilgan',
          ru: 'Продано',
          en: 'Sold',
        },
        color: 'secondary',
      },
      {
        id: 4,
        title: {
          uz: 'Band qilingan',
          ru: 'Занято',
          en: 'occupied',
        },
        color: 'primary',
      },
    ],
  },
  flat_decorations: {
    results: [],
  },
  flat_living_area_types: [],
  flat_nonliving_area_types: [],
  occupied_by_list: [],
  sale_offices: [],
  constructors: {
    results: [],
  },
  payment_interests: [],
  payment_methods: {
    results: [
      {
        id: 3,
        title: {
          ru: 'Оплата по терминалу',
          uz: "Terminal orqali to'lash",
        },
      },
      {
        id: 2,
        title: {
          ru: 'Безналичный расчёт',
          uz: 'Naqdmas',
        },
      },
      {
        id: 1,
        title: {
          ru: 'Наличные',
          uz: 'Naqd',
        },
      },
    ],
  },
  single_constructor: {
    account: {},
  },
  project_staff: {
    results: [],
  },
}
